import "./WarehouseDetails.scss";
import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import ModalDelete from "../ModalDelete/ModalDelete";
import sort from "../../assets/Icons/sort-24px.svg";
import right from "../../assets/Icons/chevron_right-24px.svg";
import trash from "../../assets/Icons/delete_outline-24px.svg";
import edit from "../../assets/Icons/edit-24px.svg";

class WarehouseDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      warehouses: [],
      selectedWarehouse: {},
      warehouseInventory: [],
      show: false,
      target: "inventory",
      id: "",
      name: "",
    };
    // Bind this to function hide / show modal so it's assigned to the state
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }
  status = "warehouse-info2__text--inStock";

  componentDidMount() {
    // this.getWarehousesData();
    this.getWarehouseById();
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log("update", this.props.match.params.id);
  }

  getWarehouseById() {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/warehouses/${this.props.match.params.id}`
      )
      .then((response) => {
        console.log("Warehouse Details", response.data);
        this.setState({
          selectedWarehouse: response.data,
        });
        return axios.get(
          `${process.env.REACT_APP_API_URL}/warehouseInventories/${this.props.match.params.id}`
        );
      })
      .then((response) => {
        console.log("Inventory List", response.data);
        this.setState({
          warehouseInventory: response.data,
        });
      })

      .catch((err) => {
        console.log(err);
      });
  }
  // function to call to show modal
  showModal = (id, name) => {
    this.setState({ show: true });
    this.setState({ id: id });
    this.setState({ name: name });
  };
  // function to call to hide modal
  hideModal = () => {
    this.setState({ show: false });
  };

  render() {
    // functions for hover event

    console.log(
      this.state.selectedWarehouse.contact &&
        this.state.selectedWarehouse.contact.name
    );
    return (
      // start of section
      <section className="warehouse-list-container2">
        {/* start of search bar */}
        <div className="search-bar2">
          <h1 className="title2">{this.state.selectedWarehouse.name}</h1>
          <div className="search-container2">
            <Link className="add-button2__link" to="/warehouse/new">
              <button className="add-button2">Edit</button>
            </Link>
          </div>
        </div>

        {/* This is the Details Section */}

        <div className="warehouse-info3 warehouse-info3--flex-start">
          <div className="warehouse-info3__box warehouse-info3__box--address2">
            <p className="warehouse-info3__title2">WAREHOUSE ADDRESS:</p>
            <p className="warehouse-info3__text">
              {this.state.selectedWarehouse.address + ", "}
            </p>
            <p className="warehouse-info3__text">
              {this.state.selectedWarehouse.city + ", "}
              {this.state.selectedWarehouse.country}
            </p>
          </div>
          <div className="warehouse-info3__box warehouse-info3__box--contact-name2">
            <p className="warehouse-info3__title2">CONTACT NAME:</p>
            <p className="warehouse-info3__text">
              {this.state.selectedWarehouse.contact &&
                this.state.selectedWarehouse.contact.name}
            </p>
            <p className="warehouse-info3__text">
              {this.state.selectedWarehouse.contact &&
                this.state.selectedWarehouse.contact.position}
            </p>
          </div>
          <div className="warehouse-info3__box warehouse-info3__box--contact-information2">
            <p className="warehouse-info3__title2">CONTACT INFORMATION:</p>
            <p className="warehouse-info3__text">
              {this.state.selectedWarehouse.contact &&
                this.state.selectedWarehouse.contact.phone}
            </p>
            <p className="warehouse-info3__text">
              {this.state.selectedWarehouse.contact &&
                this.state.selectedWarehouse.contact.email}
            </p>
          </div>
          <div className="warehouse-info3__box warehouse-info3__box--empty"></div>
        </div>

        {/* This is the top "sorting" row */}

        <div className="table-header2">
          <div className="table-header2__column table-header2__column--warehouse">
            <p className="table-header2__title">INVENTORY ITEM</p>

            <img
              className="table-header2__sort-icon"
              src={sort}
              alt="sort_icon"
            />
          </div>
          <div className="table-header2__column table-header2__column--address">
            <p className="table-header2__title">CATEGORY</p>

            <img
              className="table-header2__sort-icon"
              src={sort}
              alt="sort_icon"
            />
          </div>
          <div className="table-header2__column table-header2__column--contact-name">
            <p className="table-header2__title">STATUS</p>

            <img
              className="table-header2__sort-icon"
              src={sort}
              alt="sort_icon"
            />
          </div>
          <div className="table-header2__column table-header2__column--contact-information">
            <p className="table-header2__title">QTY</p>
            <img
              className="table-header2__sort-icon"
              src={sort}
              alt="sort_icon"
            />
          </div>
          <div className="table-header2__column table-header2__column--actions">
            <p className="table-header2__title">ACTIONS</p>
          </div>
        </div>

        {/* This is the start of the Warehouse List */}

        <ul className="warehouse-list">
          {this.state.warehouseInventory.map((item) => {
            // this is where I need to add hover event to the list item
            if (item.status === "In Stock") {
              this.status = "warehouse-info2__text--inStock";
            } else {
              this.status = "warehouse-info2__text--outStock";
            }
            return (
              <li className="warehouse-list-item2" key={item.id}>
                <div className="warehouse-info2">
                  <div className="warehouse-info2__box warehouse-info2__box--warehouse">
                    <p className="warehouse-info2__title">INVENTORY ITEM</p>
                    <Link
                      className="warehouse-info2__warehouse-link"
                      to={`/inventory/details/${item.id}`}
                    >
                      <div className="warehouse-info2__warehouse-link-box">
                        <p className="warehouse-info2__text warehouse-info2__text--link">
                          {item.itemName}
                        </p>
                        <img
                          className="warehouse-info2__right-chevron-icon"
                          src={right}
                          alt="sort_icon"
                        />
                      </div>
                    </Link>
                  </div>
                  <div className="warehouse-info2__box warehouse-info2__box--address2">
                    <p className="warehouse-info2__title">CATEGORY</p>
                    <p className="warehouse-info2__text warehouse-info2__text--wrap">
                      {item.category}
                    </p>
                  </div>
                  <div className="warehouse-info2__box warehouse-info2__box--contact-name2">
                    <p className="warehouse-info2__title">STATUS</p>
                    <p className={`warehouse-info2__text ${this.status}`}>
                      {item.status}
                    </p>
                  </div>
                  <div className="warehouse-info2__box warehouse-info2__box--contact-information2">
                    <p className="warehouse-info2__title">QTY</p>
                    <p className="warehouse-info2__text">{item.quantity}</p>
                  </div>
                </div>

                {/* action delete and edit below */}

                <div className="actions2">
                  {/* this is where I need to add the delete function */}
                  <img
                    className="actions2__icon"
                    src={trash}
                    alt="delete_icon"
                    onClick={() => this.showModal(item.id, item.itemName)}
                  />
                  <Link to={`/warehouseInventories/edit/${item.id}`}>
                    <img
                      className="actions2__icon"
                      src={edit}
                      alt="edit_icon"
                    />
                  </Link>
                </div>
              </li>
            );
          })}
        </ul>
        <ModalDelete
          show={this.state.show}
          handleClose={this.hideModal}
          target={this.state.target}
          id={this.state.id}
          name={this.state.name}
        />
      </section>
    );
  }
}

export default WarehouseDetails;
